import React from "react";
import Logo from '../../assets/Images/Docusafe_logo.webp';
const Header = (props) => {
    const userName = props.envelopeData?.user_name || "";
    const dueDateRaw = props.envelopeData?.due_date || "";

    // Format date to DD/MM/YYYY
    let dueDate = "";
    if (dueDateRaw) {
        const d = new Date(dueDateRaw);
        if (!isNaN(d.getTime())) {
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            dueDate = `${day}/${month}/${year}`;
        }
    }

    // Calculate total documents
    const totalDoc =
        (props.envelopeData?.document_list?.length || 0) +
        (props.envelopeData?.request_form_list?.length || 0) +
        (props.envelopeData?.sign_documents?.length || 0);

    return (
        <nav className="navbar navbar-expand-lg shadow-sm d-flex align-items-center justify-content-between px-4" style={{ minHeight: '60px' }}>
            <div className="d-flex flex-column align-items-start">
                <span className="navbar-brand mb-0 p-0">
                    <img src={Logo} alt="" className="docusafe_logo" style={{ height: '40px' }} />
                </span>
            </div>
            <div className="ms-auto d-flex flex-column align-items-end">
                <span className="text-primary fw-bold d-flex align-items-center" style={{ fontSize: '16px' }}>
                    Total Documents: {totalDoc}
                </span>
                <span className="fw-bold" style={{ fontSize: '20px' }}>{userName}</span>
                <span className="text-muted d-flex align-items-center" style={{ fontSize: '15px' }}>
                    Due Date: {dueDate}
                </span>
            </div>
        </nav>
    );
};

export default Header;
